import { Close } from "@mui/icons-material";
import {
  Backdrop,
  Button,
  CircularProgress,
  IconButton,
  OutlinedInput,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import styles from "./Roles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  useGetRoleByIdQuery,
  useUpdateRoleMutation,
} from "../../Store/Services/RoleService";
import { closeRoleModal } from "../../Store/Slices/brSlice";

const schema = yup
  .object({
    brName: yup.string().required(""),
  })
  .required();

const EditRole = ({ handleClose }) => {
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.roles);

  const {
    data: roleDetails,
    isSuccess: roleSuccess,
    isLoading: roleLoading,
  } = useGetRoleByIdQuery(roles.selectedRole);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (roleSuccess) {
      reset({
        brName: roleDetails?.list[0]?.brName,
      });
    }
  }, [roleDetails]);

  const [updateRole] = useUpdateRoleMutation();

  const onSubmit = async (data) => {
    const dataSet = {
      ...data,
      brId: roles.selectedRole,
    };
    try {
      const respond = await updateRole(dataSet).unwrap();
      // toast.success("Role successfully added!");
      onCloseDialog();
    } catch (err) {
      console.error("Failed to save the Role: ", err);
      toast.error("Erorr, something went wrong!");
    }
  };

  const onCloseDialog = () => {
    reset();
    dispatch(closeRoleModal());
  };

  return (
    <div>
      <div className={styles.headingContainer}>
        <Typography fontWeight={600} variant={"h6"}>
          Edit Role
        </Typography>
        <IconButton
          className={styles.closeButton}
          onClick={onCloseDialog}
          aria-label="close"
        >
          <Close />
        </IconButton>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.formItem}>
          <label className={styles.formLabel}>Name:</label>
          {errors.brName && errors.brName.type === "required" && (
            <span className={styles.validation}> *</span>
          )}
          <OutlinedInput
            {...register("brName")}
            className={styles.formInput}
            placeholder="Enter Name"
            size="small"
            fullWidth
          />
        </div>

        {/* Submit Button */}
        <div className={styles.buttonContainer}>
          <Button
            type="submit"
            className={styles.submitButton}
            variant="contained"
            aria-label="Save"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditRole;
